/* Better Days Customs design app */
(function () {
  'use strict';
  var CFG = window.BDC_DESIGN || {};
  var VECTOR = ['svg', 'pdf', 'ai', 'eps'];
  var VIEWNAME = { f: 'front', b: 'back', l: 'left sleeve', r: 'right sleeve' };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function money(cents) {
    var n = (cents / 100).toFixed(2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var v = n.join('.');
    var f = CFG.moneyFormat || '';
    if (f.indexOf('{{') > -1) return f.replace(/\{\{\s*\w+\s*\}\}/, v);
    return '$' + v;
  }

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
  }

  function locLabel(n) { return n === 0 ? 'Blank' : (n + (n === 1 ? ' location' : ' locations')); }

  var S = {
    handle: '', product: null, variants: [], sizes: [], sizeInfo: null,
    colors: [], color: null, view: 'f', areas: [], art: {}, active: null,
    qty: {}, dec: 'DTF', colorsOpen: false
  };

  var root, garmentImg, areasEl, fileInput, canvasEl, sleeveEl;

  function isSleeve(v) { return v === 'l' || v === 'r'; }

  function sampleSwatch(sw) {
    return new Promise(function (res) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = 8; c.height = 8;
          var x = c.getContext('2d');
          x.drawImage(i, 0, 0, 8, 8);
          var d = x.getImageData(0, 0, 8, 8).data;
          var r = 0, g = 0, b = 0, n = d.length / 4;
          for (var k = 0; k < d.length; k += 4) { r += d[k]; g += d[k + 1]; b += d[k + 2]; }
          res('rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')');
        } catch (e) { res('#b7bcc0'); }
      };
      i.onerror = function () { res('#b7bcc0'); };
      i.src = 'https://cdn.ssactivewear.com/Images/ColorSwatch/' + sw + '_fm.jpg';
    });
  }

  function isFleece(type) { return /sweat|fleece|hood/i.test(type || ''); }

  function sleeveSvg(type, fill) {
    var c = fill || '#b7bcc0';
    var line = 'rgba(0,0,0,.45)';
    var fleece = isFleece(type);
    var hood = fleece
      ? '<path d="M395 300 C 380 190, 470 120, 560 130 C 660 142, 700 230, 672 312 Z" fill="' + c + '" stroke="' + line + '" stroke-width="4"/>'
      : '';
    var bodyBottom = fleece ? 1010 : 1040;
    var sleeveBottom = fleece ? 980 : 620;
    var ribs = '';
    for (var i = 0; i < 8; i++) { var rx = 432 + i * 19; ribs += '<line x1="' + rx + '" y1="986" x2="' + rx + '" y2="1032"/>'; }
    var cuff = fleece
      ? '<rect x="420" y="980" width="160" height="58" rx="10" fill="' + c + '" stroke="' + line + '" stroke-width="4"/>' +
        '<g stroke="' + line + '" stroke-width="3" opacity=".55">' + ribs + '</g>'
      : '<rect x="418" y="612" width="164" height="26" rx="8" fill="' + c + '" stroke="' + line + '" stroke-width="4"/>';
    return '<svg viewBox="0 0 1000 1250" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" role="img" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="1000" height="1250" fill="#ffffff"/>' +
      hood +
      '<path d="M352 330 C 352 300, 400 286, 500 286 C 600 286, 660 300, 660 330 L 668 ' + bodyBottom +
        ' C 668 ' + (bodyBottom + 26) + ', 340 ' + (bodyBottom + 26) + ', 340 ' + bodyBottom + ' Z" fill="' + c + '" stroke="' + line + '" stroke-width="4"/>' +
      '<path d="M420 360 C 420 336, 580 336, 580 360 L 580 ' + sleeveBottom +
        ' C 580 ' + (sleeveBottom + 20) + ', 420 ' + (sleeveBottom + 20) + ', 420 ' + sleeveBottom + ' Z" fill="' + c + '" stroke="' + line + '" stroke-width="4"/>' +
      cuff +
      '<path d="M356 470 L 398 556" stroke="' + line + '" stroke-width="4" fill="none" opacity=".6"/>' +
      '</svg>';
  }

  /* ---------- data ---------- */

  function swParse(raw, handle) {
    var all = (raw || '').split('~');
    for (var i = 0; i < all.length; i++) {
      var p = all[i].indexOf('^');
      if (p > 0 && all[i].slice(0, p) === handle) {
        var out = [], q = all[i].slice(p + 1).split('|');
        for (var j = 0; j < q.length; j++) {
          var b = q[j].lastIndexOf(':'), a = q[j].lastIndexOf(':', b - 1);
          if (a < 0) continue;
          out.push({ name: q[j].slice(0, a), sw: q[j].slice(a + 1, b), img: q[j].slice(b + 1) });
        }
        return out;
      }
    }
    return [];
  }

  function loadRaw() {
    if (window.BDC_SW_RAW) return Promise.resolve(window.BDC_SW_RAW);
    return fetch(CFG.swatchUrl).then(function (r) { return r.text(); }).then(function (t) { window.BDC_SW_RAW = t; return t; });
  }

  function loadSizes() {
    if (window.BDC_SIZES) return Promise.resolve(window.BDC_SIZES);
    return fetch(CFG.sizesUrl).then(function (r) { return r.json(); }).then(function (j) { window.BDC_SIZES = j; return j; });
  }

  function loadProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) {
      if (!r.ok) throw new Error('Product not found');
      return r.json();
    });
  }

  /* ---------- pricing ---------- */

  function breaks() { return String(CFG.tierBreaks || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; }); }
  function steps() { return String(CFG.tierSteps || '').split(',').map(function (x) { return parseFloat(x) || 0; }); }
  function codes() { return String(CFG.tierCodes || '').split(',').map(function (x) { return x.trim(); }); }
  function tierIndex(q) { var b = breaks(), i = 0; for (var k = 0; k < b.length; k++) if (q >= b[k]) i = k + 1; return i; }
  function stepAt(i) { return i > 0 ? (steps()[i - 1] || 0) : 0; }

  function locCount() { return Object.keys(S.art).length; }

  function variantFor(size, locs) {
    var want = locLabel(locs);
    for (var i = 0; i < S.variants.length; i++) {
      if (S.variants[i].options[0] === size && S.variants[i].options[1] === want) return S.variants[i];
    }
    return null;
  }

  function totalQty() {
    return Object.keys(S.qty).reduce(function (t, k) { return t + (S.qty[k] || 0); }, 0);
  }

  /* ---------- render: colours ---------- */

  function renderColors() {
    var wrap = $('[data-bdc-colorwrap]', root);
    var more = $('[data-bdc-colormore]', root);
    if (!S.colors.length) { wrap.innerHTML = '<p class="bdc-colors__loading">Colour list unavailable.</p>'; return; }
    wrap.innerHTML = S.colors.map(function (c, i) {
      return '<button type="button" class="bdc-color' + (i >= 16 ? ' is-extra' : '') + '" data-ci="' + i + '" title="' + esc(c.name) + '" aria-label="' + esc(c.name) + '">' +
        '<span class="bdc-color__dot" style="background-image:url(https://cdn.ssactivewear.com/Images/ColorSwatch/' + esc(c.sw) + '_fm.jpg)"></span>' +
        '<span class="bdc-color__tip" aria-hidden="true">' + esc(c.name) + '</span></button>';
    }).join('');
    wrap.classList.toggle('has-extra', S.colors.length > 16);
    if (more) { more.hidden = S.colors.length <= 16; more.textContent = 'Show all ' + S.colors.length + ' colours'; }
    pickColor(S.color ? S.colors.indexOf(S.color) : 0);
  }

  function pickColor(i) {
    if (i < 0) i = 0;
    var c = S.colors[i];
    if (!c) return;
    S.color = c;
    $$('[data-ci]', root).forEach(function (b) { b.classList.toggle('is-active', parseInt(b.getAttribute('data-ci'), 10) === i); });
    var n = $('[data-bdc-colorname]', root); if (n) n.textContent = c.name;
    paintGarment();
    sampleSwatch(c.sw).then(function (fill) {
      S.colorFill = fill;
      if (isSleeve(S.view)) paintGarment();
    });
  }

  function paintGarment() {
    if (!S.color || !garmentImg) return;
    if (isSleeve(S.view)) {
      garmentImg.style.display = 'none';
      if (sleeveEl) {
        sleeveEl.hidden = false;
        sleeveEl.innerHTML = sleeveSvg(S.product && S.product.type, S.colorFill);
        sleeveEl.style.transform = S.view === 'r' ? 'scaleX(-1)' : 'none';
      }
      return;
    }
    if (sleeveEl) sleeveEl.hidden = true;
    garmentImg.style.display = '';
    garmentImg.src = 'https://cdn.ssactivewear.com/Images/Color/' + S.color.img + '_' + S.view + '_fl.jpg';
    garmentImg.alt = (S.product ? S.product.title : '') + ' in ' + S.color.name;
  }

  /* ---------- render: areas ---------- */

  function visibleAreas() {
    var t = (S.product && S.product.type || '').toLowerCase();
    return (CFG.areas || []).filter(function (a) {
      if (a.view !== S.view) return false;
      if (!a.types) return true;
      return a.types.toLowerCase().split(',').some(function (x) { return x.trim() && t.indexOf(x.trim()) > -1; });
    });
  }

  function renderAreas() {
    var list = visibleAreas().filter(function (a) { return a.key === S.active || S.art[a.key]; });
    areasEl.innerHTML = list.map(function (a) {
      var art = S.art[a.key];
      var inner = '';
      if (art) {
        inner = '<img class="bdc-art" src="' + esc(art.url) + '" alt="" draggable="false" ' +
                'style="left:' + art.x + '%;top:' + art.y + '%;width:' + art.w + '%;">' +
                '<span class="bdc-area__badge' + (art.dpi && art.dpi < CFG.warnDpi ? ' is-warn' : '') + '">' +
                (art.vector ? 'Vector' : Math.round(art.dpi) + ' DPI') + '</span>';
      }
      return '<div class="bdc-area' + (S.active === a.key ? ' is-active' : '') + (art ? ' has-art' : '') + '" data-area="' + esc(a.key) + '" ' +
        'style="left:' + a.x + '%;top:' + a.y + '%;width:' + a.w + '%;height:' + a.h + '%;">' +
        '<span class="bdc-area__label">' + esc(a.name) + '<em>' + esc(a.inW) + '&quot; x ' + esc(a.inH) + '&quot; max</em></span>' +
        inner + '</div>';
    }).join('') + visibleAreas().filter(function (a) { return a.key !== S.active && !S.art[a.key]; }).map(function (a) {
      return '<div class="bdc-area bdc-area--ghost" data-area="' + esc(a.key) + '" title="' + esc(a.name) + '" ' +
        'style="left:' + a.x + '%;top:' + a.y + '%;width:' + a.w + '%;height:' + a.h + '%;">' +
        '<span class="bdc-area__label">' + esc(a.name) + '</span></div>';
    }).join('');
    positionFab();
  }

  function positionFab() {
    var fab = $('[data-bdc-fab]', root);
    var a = (CFG.areas || []).filter(function (x) { return x.key === S.active; })[0];
    if (!a || a.view !== S.view) { fab.hidden = true; return; }
    fab.hidden = false;
    fab.style.left = (a.x + a.w / 2) + '%';
    fab.style.top = (a.y + a.h / 2) + '%';
    fab.classList.toggle('is-filled', !!S.art[a.key]);
  }

  /* ---------- render: locations, sizes, summary ---------- */

  function renderLocs() {
    var wrap = $('[data-bdc-locwrap]', root);
    var t = (S.product && S.product.type || '').toLowerCase();
    var all = (CFG.areas || []).filter(function (a) {
      if (!a.types) return true;
      return a.types.toLowerCase().split(',').some(function (x) { return x.trim() && t.indexOf(x.trim()) > -1; });
    });
    wrap.innerHTML = all.map(function (a) {
      var on = !!S.art[a.key];
      return '<button type="button" class="bdc-loc bdc-loc--btn' + (on ? ' is-on' : '') + '" data-loc="' + esc(a.key) + '">' +
        '<span class="bdc-loc__inner"><span class="bdc-loc__box" aria-hidden="true"></span>' +
        '<span class="bdc-loc__name">' + esc(a.name) + '</span>' +
        '<span class="bdc-loc__price">' + (on ? 'Added' : '+' + money(Math.round(CFG.locationPrice * 100))) + '</span></span></button>';
    }).join('');
    var lp = $('[data-bdc-locprice]', root); if (lp) lp.textContent = money(Math.round(CFG.locationPrice * 100));
  }

  function renderSizes() {
    var wrap = $('[data-bdc-sizerows]', root);
    var locs = locCount();
    wrap.innerHTML = S.sizes.map(function (s) {
      var v = variantFor(s, locs);
      return '<div class="bdc-sizerow"><span class="bdc-sizerow__name">' + esc(s) + '</span>' +
        '<span class="bdc-sizerow__price" data-sp="' + esc(s) + '">' + (v ? money(v.price) : '') + '</span>' +
        '<span class="bdc-step"><button type="button" class="bdc-step__btn" data-qstep="-1" data-size="' + esc(s) + '" aria-label="Decrease ' + esc(s) + '">&minus;</button>' +
        '<input type="number" min="0" step="1" class="bdc-step__input" data-qty="' + esc(s) + '" value="' + (S.qty[s] || 0) + '" aria-label="Quantity for ' + esc(s) + '">' +
        '<button type="button" class="bdc-step__btn" data-qstep="1" data-size="' + esc(s) + '" aria-label="Increase ' + esc(s) + '">+</button></span></div>';
    }).join('');
  }

  function recalc() {
    var locs = locCount();
    var q = totalQty();
    var ti = tierIndex(q);
    var pct = stepAt(ti);

    S.sizes.forEach(function (s) {
      var v = variantFor(s, locs);
      var el = $('[data-sp="' + s.replace(/"/g, '\\"') + '"]', root);
      if (el) el.textContent = v ? money(Math.round(v.price * (100 - pct) / 100)) : '';
    });

    var garment = 0, printing = 0;
    S.sizes.forEach(function (s) {
      var n = S.qty[s] || 0;
      if (!n) return;
      var base = variantFor(s, 0), v = variantFor(s, locs);
      if (!base || !v) return;
      garment += base.price * n;
      printing += (v.price - base.price) * n;
    });
    var gross = garment + printing;
    var disc = Math.floor(gross * pct / 100);
    var total = gross - disc;

    var tq = $('[data-bdc-total-qty]', root); if (tq) tq.textContent = q;
    var rows = $('[data-bdc-summary-rows]', root);
    if (rows) {
      if (!q) {
        rows.innerHTML = '<div class="bdc-summary__row bdc-summary__row--muted"><dt>Nothing selected yet</dt><dd>Pick sizes to see your price</dd></div>';
      } else {
        var h = '<div class="bdc-summary__row"><dt>Garment ' + q + (q === 1 ? ' piece' : ' pieces') + '</dt><dd>' + money(garment) + '</dd></div>' +
                '<div class="bdc-summary__row"><dt>Printing ' + (locs ? locs + (locs === 1 ? ' location' : ' locations') : 'none') + '</dt><dd>' + money(printing) + '</dd></div>';
        if (disc > 0) h += '<div class="bdc-summary__row bdc-summary__row--save"><dt>Quantity discount ' + pct + '%</dt><dd>&minus;' + money(disc) + '</dd></div>';
        rows.innerHTML = h;
      }
    }
    var tv = $('[data-bdc-total-value]', root); if (tv) tv.textContent = money(total);
    var pp = $('[data-bdc-per-piece]', root); if (pp) pp.textContent = q ? money(Math.round(total / q)) + ' per piece before delivery and tax' : '';
    S.tierIndex = ti;
  }

  function refresh() { renderAreas(); renderLocs(); renderSizes(); recalc(); }

  /* ---------- artwork ---------- */

  function ext(name) { var m = /\.([a-z0-9]+)$/i.exec(name || ''); return m ? m[1].toLowerCase() : ''; }

  function areaByKey(k) { return (CFG.areas || []).filter(function (a) { return a.key === k; })[0]; }

  function handleFile(file) {
    var key = S.active;
    var area = areaByKey(key);
    if (!area) { showErr('Pick a print area first.'); return; }
    var maxBytes = (CFG.maxUploadMb || 20) * 1024 * 1024;
    if (file.size > maxBytes) {
      modal('<h2>That file is too large</h2>' +
        '<p>' + esc(file.name) + ' is ' + (file.size / 1048576).toFixed(1) + 'MB. Shopify caps order attachments at ' + CFG.maxUploadMb + 'MB.</p>' +
        '<p>Upload a smaller version to place it here, and send the print-ready file with the artwork link field on the product page, or reply to your order confirmation.</p>' +
        '<button type="button" class="bdc-btn bdc-btn--primary" data-bdc-modal-close>Got it</button>');
      return;
    }
    var e = ext(file.name);
    var isVec = VECTOR.indexOf(e) > -1;
    var url = URL.createObjectURL(file);

    function place(natW, natH) {
      var dpi = 0;
      if (!isVec && natW) {
        dpi = natW / parseFloat(area.inW || 1);
      }
      var ratio = natH && natW ? natH / natW : 1;
      var boxRatio = (parseFloat(area.inH) || 1) / (parseFloat(area.inW) || 1);
      var w = 100, x = 0, y = 0;
      if (ratio > boxRatio) { w = (boxRatio / ratio) * 100; x = (100 - w) / 2; }
      else { y = 0; }
      S.art[key] = {
        file: file, url: url, name: file.name, vector: isVec, dpi: dpi,
        natW: natW, natH: natH, x: x, y: y, w: w
      };
      refresh();
      if (!isVec && dpi && dpi < (CFG.warnDpi || 300)) {
        showHint('About ' + Math.round(dpi) + ' DPI at this size. Under ' + (CFG.warnDpi || 300) + ' DPI may print softer than a sharp file. Scaling it down raises the DPI, or send a larger export.', true);
      } else {
        showHint('Drag the artwork to move it. Drag the corner handle to resize.', false);
      }
    }

    if (isVec) { place(0, 0); return; }
    var img = new Image();
    img.onload = function () { place(img.naturalWidth, img.naturalHeight); };
    img.onerror = function () {
      URL.revokeObjectURL(url);
      showErr('That file could not be read as an image. Try PNG, JPG or a vector file.');
    };
    img.src = url;
  }

  function showHint(msg, warn) {
    var h = $('[data-bdc-hint]', root);
    if (!h) return;
    h.textContent = msg;
    h.classList.toggle('is-warn', !!warn);
  }
  function showErr(msg) {
    var e = $('[data-bdc-err]', root);
    if (!e) return;
    e.textContent = msg; e.hidden = false;
    e.scrollIntoView({ block: 'nearest' });
  }
  function clearErr() { var e = $('[data-bdc-err]', root); if (e) { e.hidden = true; e.textContent = ''; } }

  /* ---------- drag and resize ---------- */

  function bindDrag() {
    var dragging = null;
    areasEl.addEventListener('pointerdown', function (ev) {
      var artEl = ev.target.closest('.bdc-art');
      if (!artEl) return;
      var areaEl = artEl.closest('.bdc-area');
      var key = areaEl.getAttribute('data-area');
      var art = S.art[key];
      if (!art) return;
      S.active = key; positionFab();
      var rect = areaEl.getBoundingClientRect();
      var corner = (ev.clientX - artEl.getBoundingClientRect().right > -18) && (ev.clientY - artEl.getBoundingClientRect().bottom > -18);
      dragging = { key: key, rect: rect, sx: ev.clientX, sy: ev.clientY, ox: art.x, oy: art.y, ow: art.w, mode: corner ? 'size' : 'move' };
      artEl.setPointerCapture(ev.pointerId);
      ev.preventDefault();
    });
    areasEl.addEventListener('pointermove', function (ev) {
      if (!dragging) return;
      var art = S.art[dragging.key];
      var dx = (ev.clientX - dragging.sx) / dragging.rect.width * 100;
      var dy = (ev.clientY - dragging.sy) / dragging.rect.height * 100;
      if (dragging.mode === 'move') {
        art.x = Math.max(-20, Math.min(120 - art.w, dragging.ox + dx));
        art.y = Math.max(-20, Math.min(120, dragging.oy + dy));
      } else {
        art.w = Math.max(8, Math.min(100, dragging.ow + dx));
        if (art.natW) art.dpi = art.natW / ((art.w / 100) * parseFloat(areaByKey(dragging.key).inW || 1));
      }
      var el = areasEl.querySelector('[data-area="' + dragging.key + '"] .bdc-art');
      if (el) { el.style.left = art.x + '%'; el.style.top = art.y + '%'; el.style.width = art.w + '%'; }
      var badge = areasEl.querySelector('[data-area="' + dragging.key + '"] .bdc-area__badge');
      if (badge && !art.vector) {
        badge.textContent = Math.round(art.dpi) + ' DPI';
        badge.classList.toggle('is-warn', art.dpi < CFG.warnDpi);
      }
    });
    areasEl.addEventListener('pointerup', function () { dragging = null; });
    areasEl.addEventListener('pointercancel', function () { dragging = null; });
  }

  /* ---------- mockup render ---------- */

  function renderMockup(view) {
    return new Promise(function (resolve) {
      var W = 1000, H = 1250;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H);
      var g = new Image();
      g.crossOrigin = 'anonymous';
      g.onload = function () {
        if (isSleeve(view) && view === 'r') {
          ctx.save(); ctx.translate(W, 0); ctx.scale(-1, 1);
          ctx.drawImage(g, 0, 0, W, H);
          ctx.restore();
        } else {
          ctx.drawImage(g, 0, 0, W, H);
        }
        var list = (CFG.areas || []).filter(function (a) { return a.view === view && S.art[a.key]; });
        var pending = list.length;
        if (!pending) return c.toBlob(function (b) { resolve(b); }, 'image/png');
        list.forEach(function (a) {
          var art = S.art[a.key];
          var im = new Image();
          im.onload = function () {
            var ax = a.x / 100 * W, ay = a.y / 100 * H, aw = a.w / 100 * W, ah = a.h / 100 * H;
            var dw = art.w / 100 * aw;
            var dh = im.naturalHeight ? dw * (im.naturalHeight / im.naturalWidth) : dw;
            ctx.drawImage(im, ax + art.x / 100 * aw, ay + art.y / 100 * ah, dw, dh);
            if (--pending === 0) c.toBlob(function (b) { resolve(b); }, 'image/png');
          };
          im.onerror = function () { if (--pending === 0) c.toBlob(function (b) { resolve(b); }, 'image/png'); };
          im.src = art.url;
        });
      };
      g.onerror = function () { c.toBlob(function (b) { resolve(b); }, 'image/png'); };
      if (isSleeve(view)) {
        g.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(sleeveSvg(S.product && S.product.type, S.colorFill));
      } else {
        g.src = 'https://cdn.ssactivewear.com/Images/Color/' + S.color.img + '_' + view + '_fl.jpg';
      }
    });
  }

  /* ---------- placement spec ---------- */

  function placementSpec() {
    return Object.keys(S.art).map(function (k) {
      var a = areaByKey(k), art = S.art[k];
      var inW = (art.w / 100) * parseFloat(a.inW || 0);
      var inH = art.natW && art.natH ? inW * (art.natH / art.natW) : inW;
      return a.name + ': ' + inW.toFixed(2) + ' by ' + inH.toFixed(2) + ' inches, offset ' +
        ((art.x / 100) * parseFloat(a.inW || 0)).toFixed(2) + ' right and ' +
        ((art.y / 100) * parseFloat(a.inH || 0)).toFixed(2) + ' down from the top left of the area' +
        (art.vector ? ', vector' : ', ' + Math.round(art.dpi) + ' DPI');
    }).join(' | ');
  }

  /* ---------- cart ---------- */

  function addToCart() {
    clearErr();
    var locs = locCount();
    var q = totalQty();
    if (!q) { showErr('Pick a quantity for at least one size first.'); return; }
    if (!locs) { showErr('Add artwork to at least one print location, or use Add Blank to Cart on the product page.'); return; }

    var btn = $('[data-bdc-addcart]', root);
    btn.disabled = true; btn.textContent = 'Adding to cart';

    var baseProps = {
      'Colour': S.color.name,
      'Decoration': S.dec,
      'Print locations': Object.keys(S.art).map(function (k) { return areaByKey(k).name; }).join(', '),
      'Placement': placementSpec()
    };

    var views = {};
    Object.keys(S.art).forEach(function (k) { views[areaByKey(k).view] = true; });

    Promise.all(Object.keys(views).map(function (v) {
      return renderMockup(v).then(function (b) { return { view: v, blob: b }; });
    })).then(function (mocks) {
      var order = S.sizes.filter(function (s) { return S.qty[s] > 0; });
      var first = order[0];
      var fd = new FormData();
      var v0 = variantFor(first, locs);
      fd.append('id', v0.id);
      fd.append('quantity', S.qty[first]);
      Object.keys(baseProps).forEach(function (k) { fd.append('properties[' + k + ']', baseProps[k]); });
      Object.keys(S.art).forEach(function (k) {
        var a = areaByKey(k), art = S.art[k];
        fd.append('properties[Artwork ' + a.name + ']', art.file, art.name);
      });
      mocks.forEach(function (m) {
        var vn = VIEWNAME[m.view] || m.view;
        fd.append('properties[Mockup ' + vn + ']', m.blob, S.handle + '-' + vn.replace(/ /g, '-') + '.png');
      });

      return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
          return { line: j, rest: order.slice(1) };
        });
      });
    }).then(function (res) {
      var uploaded = {};
      var p = res.line.properties || {};
      Object.keys(p).forEach(function (k) { if (/^Artwork |^Mockup /.test(k)) uploaded[k] = p[k]; });
      if (!res.rest.length) return;
      var items = res.rest.map(function (s) {
        var v = variantFor(s, locs);
        var props = {};
        Object.keys(baseProps).forEach(function (k) { props[k] = baseProps[k]; });
        Object.keys(uploaded).forEach(function (k) { props[k] = uploaded[k]; });
        return { id: v.id, quantity: S.qty[s], properties: props };
      });
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add remaining sizes'); }); });
    }).then(function () {
      var idx = tierIndex(totalQty());
      var code = codes()[idx - 1];
      window.location.href = idx > 0 && code
        ? '/discount/' + encodeURIComponent(code) + '?redirect=/cart'
        : '/cart';
    }).catch(function (e) {
      btn.disabled = false; btn.textContent = 'Add to Cart';
      showErr(e.message);
    });
  }

  /* ---------- save ---------- */

  function saveDesign() {
    clearErr();
    if (!locCount()) { showErr('Add artwork to at least one print location before saving.'); return; }
    if (!CFG.loggedIn) {
      modal('<h2>Sign in to save this design</h2>' +
        '<p>Saving keeps your placement, colour and sizes so you can come back to it. Your design stays in this browser and is linked to your account.</p>' +
        '<a class="bdc-btn bdc-btn--primary bdc-btn--block" href="/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search) + '">Sign in</a>' +
        '<a class="bdc-btn bdc-btn--outline bdc-btn--block bdc-mt12" href="/account/register?return_url=' + encodeURIComponent(window.location.pathname + window.location.search) + '">Create an account</a>' +
        '<button type="button" class="bdc-btn bdc-btn--ghost bdc-btn--block" data-bdc-modal-close>Keep designing</button>');
      return;
    }
    var key = 'bdc:designs:' + (CFG.customerId || 'me');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { list = []; }
    var rec = {
      id: 'd' + list.length + '-' + S.handle,
      handle: S.handle, title: S.product.title, colour: S.color.name,
      dec: S.dec, qty: S.qty,
      art: Object.keys(S.art).map(function (k) {
        var a = S.art[k];
        return { key: k, name: a.name, x: a.x, y: a.y, w: a.w, vector: a.vector, dpi: a.dpi };
      })
    };
    list.push(rec);
    var ok = true;
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) { ok = false; }

    modal('<h2>' + (ok ? 'Design saved' : 'Could not save in this browser') + '</h2>' +
      (ok
        ? '<p>Saved to this browser under your account. Placement and sizes are kept. Your artwork file stays on your computer, so re-attach it if you come back on another device.</p>'
        : '<p>Your browser blocked local storage, so the design was not kept. You can still add it to your cart right now.</p>') +
      '<button type="button" class="bdc-btn bdc-btn--primary bdc-btn--block" data-bdc-modal-cart>Add to Cart</button>' +
      '<button type="button" class="bdc-btn bdc-btn--outline bdc-btn--block bdc-mt12" data-bdc-modal-close>Keep designing</button>');
  }

  /* ---------- modal ---------- */

  function modal(html) {
    var m = $('[data-bdc-modal]', root);
    $('[data-bdc-modal-panel]', root).innerHTML = html;
    m.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function closeModal() {
    var m = $('[data-bdc-modal]', root);
    if (m) m.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ---------- drawer ---------- */

  function openDrawer() {
    var d = $('[data-bdc-drawer]', root);
    var g = $('[data-bdc-drawergrid]', root);
    g.innerHTML = S.colors.map(function (c, i) {
      return '<button type="button" class="bdc-swatchcard' + (S.color === c ? ' is-active' : '') + '" data-dci="' + i + '">' +
        '<span class="bdc-swatchcard__dot" style="background-image:url(https://cdn.ssactivewear.com/Images/ColorSwatch/' + esc(c.sw) + '_fm.jpg)"></span>' +
        '<span class="bdc-swatchcard__name">' + esc(c.name) + '</span></button>';
    }).join('');
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = $('[data-bdc-drawer]', root);
    if (d) d.hidden = true;
    document.documentElement.style.overflow = '';
  }

  /* ---------- events ---------- */

  function bind() {
    $('[data-bdc-views]', root).addEventListener('click', function (e) {
      var b = e.target.closest('[data-bdc-view]');
      if (!b) return;
      S.view = b.getAttribute('data-bdc-view');
      $$('[data-bdc-view]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
      paintGarment(); renderAreas();
    });

    areasEl.addEventListener('click', function (e) {
      if (e.target.closest('.bdc-art')) return;
      var a = e.target.closest('[data-area]');
      if (!a) return;
      S.active = a.getAttribute('data-area');
      renderAreas();
      if (!S.art[S.active]) openPicker();
    });

    $('[data-bdc-fab]', root).addEventListener('click', openPicker);

    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      fileInput.value = '';
      if (f) handleFile(f);
    });

    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-ci]');
      if (c) { pickColor(parseInt(c.getAttribute('data-ci'), 10)); return; }
      var dc = e.target.closest('[data-dci]');
      if (dc) { pickColor(parseInt(dc.getAttribute('data-dci'), 10)); closeDrawer(); return; }
      var lb = e.target.closest('[data-loc]');
      if (lb) {
        var k = lb.getAttribute('data-loc');
        var ar = areaByKey(k);
        S.active = k;
        if (S.art[k]) { URL.revokeObjectURL(S.art[k].url); delete S.art[k]; refresh(); }
        else { S.view = ar.view; $$('[data-bdc-view]', root).forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-bdc-view') === S.view); }); paintGarment(); renderAreas(); openPicker(); }
        return;
      }
      var qs = e.target.closest('[data-qstep]');
      if (qs) {
        var sz = qs.getAttribute('data-size');
        S.qty[sz] = Math.max(0, (S.qty[sz] || 0) + parseInt(qs.getAttribute('data-qstep'), 10));
        var inp = $('[data-qty="' + sz.replace(/"/g, '\\"') + '"]', root);
        if (inp) inp.value = S.qty[sz];
        recalc();
        return;
      }
      if (e.target.closest('[data-bdc-modal-close]')) { closeModal(); return; }
      if (e.target.closest('[data-bdc-modal-cart]')) { closeModal(); addToCart(); return; }
      if (e.target.closest('[data-bdc-drawer-close]')) { closeDrawer(); return; }
      if (e.target.closest('[data-bdc-colormore]')) { openDrawer(); return; }
      if (e.target.closest('[data-bdc-save]') || e.target.closest('[data-bdc-save2]')) { saveDesign(); return; }
      if (e.target.closest('[data-bdc-addcart]')) { addToCart(); return; }
      if (e.target.closest('[data-bdc-removeart]')) {
        if (S.active && S.art[S.active]) { URL.revokeObjectURL(S.art[S.active].url); delete S.art[S.active]; refresh(); }
        return;
      }
      if (e.target.closest('[data-bdc-center]')) {
        var art = S.art[S.active];
        if (art) { art.x = (100 - art.w) / 2; renderAreas(); }
        return;
      }
      if (e.target.closest('[data-bdc-fit]')) {
        var a2 = S.art[S.active];
        if (a2) { a2.w = 100; a2.x = 0; if (a2.natW) a2.dpi = a2.natW / parseFloat(areaByKey(S.active).inW || 1); renderAreas(); }
        return;
      }
      if (e.target.closest('[data-bdc-switch]')) { window.location.href = '/collections/all'; return; }
    });

    root.addEventListener('input', function (e) {
      var i = e.target.closest('[data-qty]');
      if (!i) return;
      S.qty[i.getAttribute('data-qty')] = Math.max(0, parseInt(i.value, 10) || 0);
      recalc();
    });

    $$('[data-bdc-dec]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        S.dec = r.value;
        var n = $('[data-bdc-decnote]', root);
        if (n) n.textContent = r.value === 'Embroidery'
          ? 'Embroidery is priced on stitch count after we review the artwork. Add it to the cart and we will confirm before production.'
          : '';
      });
    });

    var search = $('[data-bdc-colorsearch]', root);
    if (search) search.addEventListener('input', function () {
      var t = search.value.toLowerCase();
      $$('[data-dci]', root).forEach(function (b) {
        b.hidden = t && b.textContent.toLowerCase().indexOf(t) === -1;
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeModal(); closeDrawer(); }
    });

    bindDrag();
  }

  function openPicker() {
    if (!S.active) { showHint('Click a print area on the garment first.', true); return; }
    fileInput.click();
  }

  /* ---------- boot ---------- */

  function boot() {
    root = $('[data-bdc-design]');
    if (!root) return;
    garmentImg = $('[data-bdc-garment]', root);
    areasEl = $('[data-bdc-areas]', root);
    canvasEl = $('[data-bdc-canvas]', root);
    sleeveEl = $('[data-bdc-sleeve]', root);
    fileInput = $('[data-bdc-file]', root);
    fileInput.setAttribute('accept', CFG.accept || '');

    S.handle = param('product') || CFG.defaultHandle;
    var wantColor = param('color');

    Promise.all([loadProduct(S.handle), loadRaw(), loadSizes()]).then(function (r) {
      S.product = r[0];
      S.variants = r[0].variants;
      var seen = {};
      S.sizes = [];
      S.variants.forEach(function (v) { if (!seen[v.options[0]]) { seen[v.options[0]] = 1; S.sizes.push(v.options[0]); } });
      S.colors = swParse(r[1], S.handle);
      S.sizeInfo = r[2][S.handle] || null;

      $('[data-bdc-prodname]', root).textContent = S.product.title;
      var back = $('[data-bdc-backlink]', root);
      if (back) back.href = '/products/' + S.handle;

      if (wantColor) {
        for (var i = 0; i < S.colors.length; i++) if (S.colors[i].name === wantColor) { S.color = S.colors[i]; break; }
      }
      renderColors();
      var firstArea = (CFG.areas || []).filter(function (a) { return a.view === 'f'; })[0];
      S.active = firstArea ? firstArea.key : null;
      refresh();
      bind();
    }).catch(function (e) {
      root.innerHTML = '<div class="bdc-wrap"><h1>We could not load that product</h1><p>' + esc(e.message) +
        '</p><p><a class="bdc-btn bdc-btn--primary" href="/collections/all">Browse products</a></p></div>';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
